import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { Award } from '../../../../models/award.interface';
import { awardsService } from '../../../../services/awards.service';

export function AwardsSection() {
    const { lang, t } = useLanguage();
    const [awards, setAwards] = useState<Award[]>([]);

    useEffect(() => {
        setAwards(awardsService.getAwards());
    }, []);

    return (
        <SectionWrapper id="awards" title={t('section.awards')} alternate>
            <div className="space-y-3">
                {awards.map(award => (
                    <div key={award.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-white dark:hover:bg-slate-800 transition-colors">
                        <span className="shrink-0 text-sm font-mono font-medium text-blue-600 dark:text-blue-400 w-12 pt-0.5">
                            {award.year}
                        </span>
                        <div>
                            <p className="font-medium text-slate-900 dark:text-white">
                                {award.title[lang]}
                            </p>
                            <p className="text-sm text-slate-500 dark:text-slate-400">
                                {award.issuer[lang]}
                                {award.description && ` · ${award.description[lang]}`}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
